module.exports = __webpack_public_path__ + "assets/img/block-b5494549.png";